export const DisplayType = {
    Difference: '分业务线统计',
    All: '所有业务线整体统计',
};

export const ProjectDimension = {
    INVESTIGATION_AREA: '项目领域',
    INVESTIGATION_STAGE: '项目阶段',
    IS_SINGLE: '是否单中心项目',
    INVESTIGATION_BY_STAGE: '项目分期',
};


// WEBPACK FOOTER //
// ./src/components/homePage/constants/common.js